import { render, staticRenderFns } from "./LcaDownstreamTransportation.vue?vue&type=template&id=580bbae8"
import script from "./LcaDownstreamTransportation.vue?vue&type=script&lang=js"
export * from "./LcaDownstreamTransportation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports